// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_YSp","cls2":"BulkFollowListModal-cls2_jQ4 BulkFollowListModal-cls1_YSp"};